import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import { Button } from "components/ui/button";
import { Loader } from "lucide-react";
import { Service } from "utils/services";
import TimePicker from "components/app/function/TimePicker";

interface ClockTimePopoverProps {
  item: any;
  index: number;
  label: string; // "Time In", "Break Out", etc.
  fieldKey: string; // "in_time", "break_out_time", etc.
  openPopoverIndex: number | null;
  setOpenPopoverIndex: (index: number | null) => void;
  timeValue: string;
  onChangeTime: (index: number, value: string) => void;
  onSubmitTime: (label: string, id: any, index: number) => void;
  loading: boolean;
  attendanceSetting: {
    late_exception: number;
  };
}

const ClockTimesheetPopover: React.FC<ClockTimePopoverProps> = ({
  item,
  index,
  label,
  fieldKey,
  openPopoverIndex,
  setOpenPopoverIndex,
  timeValue,
  onChangeTime,
  onSubmitTime,
  loading,
  attendanceSetting,
}) => {
  const fieldTime = item?.[fieldKey];
  const startingTime = item?.starting_time;
  const breakStartingDatetime = item?.break_starting_datetime;
  const breakEndingDatetime = item?.break_ending_datetime;

  const getTextColor = () => {
    if (!startingTime) return "text-gray-500";
    if (!fieldTime) return "text-red-500";
    if (fieldKey === "in_time" && fieldTime > startingTime) {
      if (item.late_in > attendanceSetting.late_exception) return "text-red-500";
      if (item.late_in > 0) return "text-yellow-500";
    }
    return "";
  };

  return (
    <Popover open={openPopoverIndex === index} onOpenChange={(isOpen) => setOpenPopoverIndex(isOpen ? index : null)}>
      <PopoverTrigger asChild>
        <p className={`font-bold text-[15px]  cursor-pointer my-2 ${getTextColor()}`}>
          {/* {breakStartingDatetime && breakEndingDatetime && <>{!startingTime ? "OFF" : !fieldTime ? "A" : Service.formatTime(fieldTime)}</>} */}
          <>{!startingTime ? "OFF" : !fieldTime ? "A" : Service.formatTime(fieldTime)}</>
        </p>
      </PopoverTrigger>
      <PopoverContent className="w-auto" forceMount>
        <div className="grid gap-4">
          <div className="space-y-2">
            <h4 className="font-medium leading-none">{label}</h4>
          </div>
          <div className="flex items-center gap-2">
            <TimePicker value={timeValue || ""} onChange={(val) => onChangeTime(index, val)} />
            <div className="flex justify-end items-center gap-4">
              <Button className="px-5 dark:text-white" onClick={() => onSubmitTime(label, item.id, index)}>
                {loading ? <Loader className="animate-spin" /> : "Save"}
              </Button>
            </div>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default ClockTimesheetPopover;
